// extracted by mini-css-extract-plugin
export var item = "submenu-module--item--3d325";
export var link = "submenu-module--link--16f5f";
export var link__active = "submenu-module--link__active--de57b";
export var spin = "submenu-module--spin--6f6c1";
export var submenu = "submenu-module--submenu--ba1ea";
export var submenu__long = "submenu-module--submenu__long--a0aee";
export var submenu__popover = "submenu-module--submenu__popover--c9d37";